import street1 from "../../assets/street1.jpg";
import street2 from "../../assets/street2.jpg";
import street3 from "../../assets/street3.jpg";
import street4 from "../../assets/street4.jpg";
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Street.css";
const imgSlider = [
  { image: street1 },
  { image: street2 },
  { image: street3 },
  { image: street4 },
];

const Street = () => {
  const settings = {
    infinite: true,
    speed: 500,

    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        // settings: { slidesToShow: 1 },
        settings: { slidesToShow: 3 },
      },
    ],
  };

  return (
    <div className="main-box">
      <Slider {...settings}>
        {imgSlider.map((item, index) => (
          <div key={index} className="card">
            <img
              src={item.image}
              alt="img"
              className="slider-img"
              style={{
                width: "95%",
                height: "300px",
                objectFit: "cover",
                display: "block",
                margin: "0 auto",
              }}
            />
            <hr />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Street;
